import { useState, useEffect } from 'react'
import Weatherpanel from "./weatherpanel.js"
import Weathergraphpanel from "./weathergraphpanel.js"
import Movie from "./movie.js"
import invoke from "../calllambda"
import styles from './css/realtimemonitor.module.css'

export default function Realtimemonitor(props) {
    const [data, setData] = useState({});
    const [camcode, setCamcode] = useState(null);

    useEffect(() => {
        if (props.point && props.point.sensors && props.point.sensors.weather.length>0) {
            invoke("arn:aws:lambda:ap-northeast-1:068557983663:function:sensordata", { sensor_id: props.point.sensors.weather[0].id }).then(function (value) {
                setData(value);
            });
        } else {
            setData({});
        }
        setCamcode(props.point.camcode.value)
    }, [props.point,props.point.camcode.value]);

    return (
        <>
            <div className={styles.weatherpannel_container}>
                <Weatherpanel point={props.point } />
            </div>
            <div className={styles.flex}>
                <div className={styles.weather_container}>
                    {data.datetime ? (<Weathergraphpanel height={220} data={data} />) : "データがありません"}
                </div>
                <div className={styles.movie_container}>
                    {camcode != null && props.point.sensors.camera.length > 0 ? (<Movie url={"https://"+props.point.sensors.camera[0].domain+"/"+camcode+"/tmp/live/stream.m3u8"} width={"100%"} height={"100%"} />) : "動画が送信されていません"}
                </div>
            </div>
        </>
    )
}
